import { mapActions } from 'vuex';
import TeamSettingsModal from '@/containers/top-menu/header/profile-settings/team/TeamModal';
import TenderMembersModal from '@/containers/top-menu/header/tender/contractor/TenderMembersModal';
import ProjectSettingsModal from '@/containers/top-menu/header/project-settings/Modal';

/*
Пример query для открытия модального окна
?modal=teamSettings
 */
const MODALS = {
  teamSettings: {
    component: TeamSettingsModal,
    context: {
      attributes: {
        class: 'my-team-modal team-modal',
      },
    },
  },
  members: {
    component: TenderMembersModal,
  },
  projectSettings: {
    component: ProjectSettingsModal,
    context: {
      createForm: false,
      attributes: {
        class: 'create-tender__container',
      },
      update: () => {
        this.$emit('deleteProject');
      },
    },
  },
};

const openModal = {
  updated() {
    let modal = this.$route.query.modal;
    if (modal && modal in MODALS) {
      this.openModal(MODALS[modal]);
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
  },
};

export default openModal;
